module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-order-table"
  }, [(_vm.orders.length > 0) ? _c('orders', {
    attrs: {
      "orderList": _vm.orders
    }
  }) : _c('div', {
    staticClass: "empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/profile/empty-cart.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'FooterShop'
      }
    }
  }, [_c('p', [_c('Button', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "type": "text"
    }
  }, [_vm._v(_vm._s(_vm.$t('shopping_card_go_to_shopping')) + " "), _c('Icon', {
    attrs: {
      "type": "chevron-right"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c232f802","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/Order/Ongoing.vue
// module id = 850
// module chunks = 0